import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { DeliveryNote, PalettenModus } from '../../types/delivery-note';
import { CommonModule } from '@angular/common';
import { DeliveryNoteChangedPipe } from '../../pipes/delivery-note-changed.pipe';

import { BadgeComponent, IconComponent, TranslatePipe, CardComponent, CardHeaderComponent, CardLeadingComponent, CardTrailingComponent, CardBodyComponent, CardDescriptionComponent, CardTitleComponent } from '@softline/ui-core';
import { ProgressBarComponent, DsProgressBarComponent } from '@softline/ui-core/progress';
import { ChipComponent } from '@softline/ui-core';
import { Auslieferungsstatus } from '../../types/palette';
@Component({
  // tslint:disable-next-line:component-selector
  selector: 'soft-delivery-note-card',
  imports: [
    CommonModule,
    DeliveryNoteChangedPipe,
    BadgeComponent,
    ChipComponent,
    IconComponent,
    ProgressBarComponent,
    TranslatePipe,
    CardComponent,
    CardHeaderComponent,
    CardLeadingComponent,
    CardTrailingComponent,
    CardBodyComponent,
    CardDescriptionComponent,
    CardTitleComponent,
    DsProgressBarComponent,
  ],
  templateUrl: './delivery-note-card.component.html',
  styleUrls: ['./delivery-note-card.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DeliveryNoteCardComponent {
  readonly deliveryNote = input<DeliveryNote>();

  protected readonly PalettenModus = PalettenModus;
  protected readonly Auslieferungsstatus = Auslieferungsstatus;
  protected readonly PALETTEN_LIMIT = 6;

  protected readonly palettenModus = computed(() => {
    const item = this.deliveryNote();
    if (!item) return;
    return item.palettenModus as string;
  });

  protected readonly numOfErledigtPaletten = computed(() => {
    const paletten = this.deliveryNote()?.paletten;
    const modus = this.deliveryNote()?.palettenModus;
    if (!paletten || !modus) return;
    switch (modus) {
      case PalettenModus.Erledigt:
        return paletten.length;
      case PalettenModus.Beladen:
        return paletten.filter(
          (p) => p.auslieferungsstatus === Auslieferungsstatus.Beladen
        ).length;
      case PalettenModus.Entladen:
        return paletten.filter(
          (p) => p.auslieferungsstatus === Auslieferungsstatus.Entladen
        ).length;
      default:
        return 0;
    }
  });

  protected readonly progressBarValue = computed(() => {
    const numOfPaletten = this.deliveryNote()?.paletten.length;
    const numOfErledigtPaletten = this.numOfErledigtPaletten();
    if (!numOfPaletten || !numOfErledigtPaletten) return 0;
    return (numOfErledigtPaletten / numOfPaletten) * 100;
  });
}
